import styled from "styled-components";

import { Box } from "ds/Box";
import { ColorPurpleLight } from "ds/Core";

export const StyledAvatarContainer = styled(Box)`
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${ColorPurpleLight};
  }
`;
